import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const DivisionDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Division"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Division">
                {getFieldDecorator('division', {
                 initialValue: data.division,
                  rules: [{ required: true, message: 'Please input the Division!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default DivisionDialogForm;
